import { API } from "../urls";

// Cookie-based auth: credentials: 'include' ile access_token cookie otomatik gönderilir
const getHeaders = () => ({
    "Content-Type": "application/json",
});

const fetchOpts = { credentials: 'include' };

export const fetchBizimhesapSettings = async (companyId) => {
    const res = await fetch(API.bizimhesap_settings_company(companyId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const upsertBizimhesapSettings = async (data) => {
    const res = await fetch(API.bizimhesap_settings_upsert, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

export const deleteBizimhesapSettings = async (id) => {
    const res = await fetch(API.bizimhesap_settings_delete(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const testBizimhesapConnection = async (companyId) => {
    const res = await fetch(API.bizimhesap_test_connection(companyId), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const fetchBizimhesapSyncQueue = async (companyId, { status, page, size } = {}) => {
    const res = await fetch(API.bizimhesap_sync_queue(companyId, { status, page, size }), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const retryBizimhesapSyncItem = async (companyId, queueId) => {
    const res = await fetch(API.bizimhesap_sync_queue_retry(companyId, queueId), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};
